import React from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const BreadcrumbNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);
  const { isLogin } = useAuth();
  return (
    <Box sx={{ p: 2 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Link
          underline="hover"
          color="inherit"
          onClick={() => {
            if (isLogin) navigate('/chat');
            else navigate('/home/Home');
          }}
          sx={{ cursor: 'pointer' }}
        >
          Home
        </Link>
        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;
          const formattedValue = (
            value.charAt(0).toUpperCase() + value.slice(1)
          )
            .split('-')
            .join(' ');
          return isLast ? (
            <Typography variant="body1" key={value}>
              {formattedValue}
            </Typography>
          ) : (
            <Link
              underline="hover"
              onClick={() => navigate(`/${value}`)}
              sx={{ cursor: 'pointer' }}
              key={value}
            >
              {formattedValue}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbNavbar;
